import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import { Card, CardContent, CardHeader } from '@/components/ui/card'

const FIELD_COUNT = 10

const SubmittalDetailSkeleton: React.FC = () => {
  return (
    <div className="space-y-4">
      {/* Header: back button, number, title, status + rev badges, owners line */}
      <div>
        <div className="flex items-center gap-2 mb-1.5">
          <Skeleton className="h-8 w-8 rounded-md shrink-0" />
          <Skeleton className="h-3 w-14 shrink-0" />
          <Skeleton className="h-6 flex-1 max-w-sm" />
          <Skeleton className="h-5 w-20 rounded-full shrink-0" />
          <Skeleton className="h-5 w-14 rounded-full shrink-0" />
        </div>
        <Skeleton className="h-4 w-48 ml-10" />
      </div>

      {/* Fields card */}
      <Card className="shadow-sm border-0">
        <CardHeader className="flex flex-row items-center justify-between space-y-0">
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-8 w-20" />
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
            {Array.from({ length: FIELD_COUNT }).map((_, i) => (
              <div key={i} className="space-y-1.5">
                <Skeleton className="h-3 w-20" />
                <Skeleton className="h-4 w-32" />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Attachments card */}
      <Card className="shadow-sm border-0">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 gap-2">
          <Skeleton className="h-5 w-28" />
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-24" />
            <Skeleton className="h-8 w-32" />
          </div>
        </CardHeader>
        <CardContent className="space-y-1.5">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-9 w-full" />
          ))}
        </CardContent>
      </Card>
    </div>
  )
}

export default SubmittalDetailSkeleton
